import { render, staticRenderFns } from "./upload-code.vue?vue&type=template&id=9c328144&scoped=true&"
import script from "./upload-code.vue?vue&type=script&lang=js&"
export * from "./upload-code.vue?vue&type=script&lang=js&"
import style0 from "./upload-code.vue?vue&type=style&index=0&id=9c328144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c328144",
  null
  
)

export default component.exports